// import { Route, Routes } from 'react-router-dom';
// import './App.css';
// import Main from './containers/Main';
// import AuthProviderWithHistory from './auth/AuthProviderWithHistory';
// import PrivateRoute from './components/PrivateRoute';
// import IdleTimerProvider from "./components/common/IdleTimerComponent";
// import Unauthorized from './components/common/UnauthorizedPage';
// import { PERMISSIONS } from './auth/permission-config';
// import Callback from './auth/CallBack';

// export function App() {
//   return (
//     <AuthProviderWithHistory>
//       <IdleTimerProvider>
//         <Routes>
//           <Route path="/callback" element={<Callback />} />
//           <Route
//             path="/unauthorized"
//             element={<Unauthorized />}
//           />
//           <Route
//             exact
//             path="*"
//             element={
//               //<PrivateRoute requiredPermissions={[]}>
//               // Testing for QA and Stage
//               <PrivateRoute
//                 anyOf={[
//                   PERMISSIONS.RMS_VIEW,
//                   PERMISSIONS.REPORTS_VIEW,
//                   PERMISSIONS.AUDITS_VIEW,
//                   PERMISSIONS.UM_VIEW,
//                 ]}
//               >
//                 <Main />
//               </PrivateRoute>
//             }
//           />
//         </Routes>
//       </IdleTimerProvider>
//     </AuthProviderWithHistory>
//   )
// }

import { Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import './App.css';
import Main from './containers/Main';
import AuthProviderWithHistory from './auth/AuthProviderWithHistory';
import PrivateRoute from './components/PrivateRoute';
import IdleTimerProvider from './components/common/IdleTimerComponent';
import Unauthorized from './components/common/UnauthorizedPage';
import { PERMISSIONS } from './auth/permission-config';
import Callback from './auth/CallBack';

import { queryClient } from './query/queryClient';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProviderWithHistory>
        <IdleTimerProvider>
          <Routes>
            <Route path="/callback" element={<Callback />} />

            <Route
              path="/unauthorized"
              element={<Unauthorized />}
            />

            <Route
              path="*"
              element={
                <PrivateRoute
                  anyOf={[
                    PERMISSIONS.RMS_VIEW,
                    PERMISSIONS.REPORTS_VIEW,
                    PERMISSIONS.AUDITS_VIEW,
                    PERMISSIONS.UM_VIEW,
                  ]}
                >
                  <Main />
                </PrivateRoute>
              }
            />
          </Routes>
        </IdleTimerProvider>
      </AuthProviderWithHistory>
    </QueryClientProvider>
  );
}
